/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ButtonProps, DialogContentProps, DialogProps, ICON_ADD_CIRCLE, useDialogStore } from '@squiz/sds';
import { AI_IDS, AI_STRINGS } from 'apps/artificial-intelligence/src/Constants/Strings.constants';
import { DialogLauncher } from 'apps/console-core/src/Components/DialogLauncher/DialogLauncher';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SemanticAuditorCreateTestDialogContent } from '../SemanticAuditorCreateTestDialogContent/SemanticAuditorCreateTestDialogContent';

export const SemanticAuditorCreateTestDialogLauncher = (): JSX.Element => {
  const { t } = useTranslation();
  const labels = {
    createTest: t(AI_STRINGS.createTest),
  };

  const launcherProps: ButtonProps = {
    classes: 'semantic-auditor__create-test-btn',
    dataId: AI_IDS.createTestDialogLauncher,
    icon: ICON_ADD_CIRCLE,
    text: labels.createTest,
  };
  const dialogProps: DialogProps = {
    classes: 'semantic-auditor-create-test-dialog',
    dialogContent: {
      renderContent: (props: DialogContentProps) => <SemanticAuditorCreateTestDialogContent {...props} />,
    },
    heading: labels.createTest,
    icon: ICON_ADD_CIRCLE,
    stateHandler: useDialogStore,
  };
  return <DialogLauncher buttonProps={launcherProps} dialogProps={dialogProps} />;
};
